/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const carouselProviderSX: SxProps<Theme> = (theme) => ({
	position: 'relative',
	py: 0,
	px: globalBreak({mobile:2, desktop:4}),
	// mt: 3,
	// height: '320px',
	[theme.breakpoints.down(600)]: {
		'.carousel__slider.carousel__slider--horizontal': {
			height: 'inherit',
			'> .carousel__slider-tray-wrapper.carousel__slider-tray-wrap--horizontal': {
				height: 'inherit',
				'> .carousel__slider-tray.carousel__slider-tray--horizontal': {
					height: 'inherit',
					'> .carousel__slide': {
						height: 'inherit',
					},
				},
			},
		},
	},

	'.carousel__back-button, .carousel__next-button': {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
		height: (theme) => theme.spacing(5),
		width: (theme) => theme.spacing(5),
		borderRadius: '50%',
		background: 'none',
		border: '1px solid transparent',
        color:'#000000',
		'&:hover': {
			cursor: 'pointer',
			color: 'primary.main',
			borderColor: 'primary.light',
		},
	},

	'.carousel__back-button': {
		left: '-15px',
	},

	'.carousel__next-button': {
		right: '-15px',
	},

	'.carousel__slider': {
		overflow: 'hidden',
	},

	div: {
		outline: 'none',
	},

	'.carousel__slide': {
		boxSizing: 'border-box',
		px: globalBreak({ mobile: 0.75, desktop: 2 }),
	},
	'.carousel__slide a:focus-visible': {
		outlineOffset:0,
	},
	'.carousel__inner-slide':{
		py:'2px !important'
	}
});

export const carouselProviderSpaceSX:SxProps<Theme> = (them) =>({
	px: globalBreak({mobile:0, desktop:0}),
})